<template lang="pug">
.briq-form-element
  label {{ label }}
  briq-required-and-optional-markers(:isRequired="isRequired" :hideOptionalMarker="hideOptionalMarker" :label="label")
  briq-tooltip(:help="help")
  .radio-buttons
    label.radio-wrapper(v-for="v in options")
      input.hidden-input(
        type="radio"
        :id="optionId(v)"
        :value="v"
        v-model="innerValue"
        )
      span.visual-button.type-bold(:for="optionId(v)") {{ optionLabel(v) }}
  .validation-message(v-if="error") {{ error }}
</template>

<script>
export default {
  name: 'BriqRadioButtons',
  props: {
    value: [String, Object],
    options: Array,
    label: String,
    help: String,
    error: String,
    hideOptionalMarker: {
      type: Boolean,
      default: false,
    },
    trackValue: String,
    displayField: String,
  },
  data() {
    return {
      innerValue: this.value,
    }
  },
  computed: {
    isRequired() {
      return this.$attrs.required || this.required
    },
  },
  methods: {
    select(v) {
      const trackValue = this.getTrackValue(v)
      this.$emit('input', trackValue)
    },
    getTrackValue(v) {
      return this.trackField ? v[this.trackField] : v
    },
    isSelected(v) {
      return this.value.includes(this.getTrackValue(v))
    },
    optionLabel(v) {
      return this.displayField ? v[this.displayField] : v
    },
    optionId(v) {
      return `toggle-${this.optionLabel(v).toLowerCase()}`
    },
  },
  watch: {
    value(v) {
      this.innerValue = v
    },
    innerValue(v) {
      this.$emit('input', v)
    },
  },
}
</script>

<style scoped lang="stylus">
border-color = #e2e2e2

.radio-buttons
  display flex
  flex-flow row wrap
  justify-content flex-start

.visual-button
  background white
  text-align center
  padding 2px 12px
  border solid 1px border-color
  color #2c333a
  display flex
  align-items center
  cursor pointer
  margin-top 8px
  border-collapse collapse
  border-left none

.radio-wrapper
  border-collapse collapse

.radio-wrapper:first-child > .visual-button
  border-left 1px solid border-color
  border-radius 3px 0 0 3px

.radio-wrapper:last-child > .visual-button
  border-radius 0 3px 3px 0

.hidden-input
  opacity 0
  width 0
  height 0
  display block

  &:checked + .visual-button
    background #4e5a6a
    color #fff

.toggle-all-button
  margin-top 8px
  text-decoration underline
  color #4e5a6a

.toggle-all-button:hover
  color black
</style>
